module.exports = __webpack_public_path__ + "static/how-to-create-contest-9de3f3187aa907818a01c9278a7e4a4d.png";